export const formatCreatePasswordForSimplified = (values) => {
  console.log('values', values)
  return {
    username: values?.cpf || '',
    password: values?.password || '',
    confirmPassword: values?.confirmPassword,
    email: values?.email || '',
    acceptPrivacyPolicy: values?.usePrivacyPolicy || false,
    acceptTermOfUse: values?.useTerms || false,
    acceptRegulation: values?.useRegulation || false,
    newsletter: values?.newsletter || false,
  }
}
